export default __webpack_public_path__ + "static/0665-028fb2cf168323ebb23d60cac657fe8c.jpg";